import acInterceptor from "../acInterceptor";

import { getSessionID } from "redline-client-sdk";
import { transformPayload } from "./transformPayload";
import type { SimulatedDebtRequest, SimulatedDebtResponse } from "./types";

const headers = {
	"Content-Type": "application/json;charset=UTF-8",
};

const useApiSimulatedDebt = () => {
	const send = (payload: SimulatedDebtRequest) => {
		const headersBeforeRequest = {
			"Session-ID": getSessionID(),
		};

		const params =
			payload?.sortField && payload?.sortType
				? `?sortField=${payload.sortField}&sortType=${payload.sortType}`
				: "";
		const usedPath = `/api/divida/buscar${params}`;
		const fmtPayload = transformPayload(payload);

		const run = () =>
			acInterceptor({
				baseURL: payload.msUrl,
				headersBeforeRequest,
			}).Post<SimulatedDebtResponse>(usedPath, fmtPayload, {
				headers: headers,
			});

		const maxAttempts = 5;
		let lastError: unknown;
		return (async () => {
			for (let attempt = 0; attempt < maxAttempts; attempt++) {
				try {
					return await run();
				} catch (error) {
					lastError = error;
				}
			}
			throw lastError;
		})();
	};

	return { apiSimulatedDebt: { send } };
};

export default useApiSimulatedDebt;
